import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, green } from '../colors';
import { GetThemeOptions } from '../../theme';
import { unityLightTokens, unityDarkTokens } from '@/theme/unityTokens';

export const successColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  const { panwRebrandStubYear } = opts;
  if (panwRebrandStubYear) {
    return mode === 'light'
      ? {
          main: unityLightTokens['--status-success-color-main'],
          highContrast: unityLightTokens['--status-success-color-high-contrast'],
          lowContrast: unityLightTokens['--status-success-color-low-contrast'],
        }
      : {
          main: unityDarkTokens['--status-success-color-main'],
          highContrast: unityDarkTokens['--status-success-color-high-contrast'],
          lowContrast: unityDarkTokens['--status-success-color-low-contrast'],
        };
  }

  return mode === 'light'
    ? {
        main: green[500],
        highContrast: green[700],
        lowContrast: green[100],
      }
    : {
        main: green[400],
        highContrast: green[100],
        lowContrast: green[800],
      };
};
